import React from "react";

import { usePlatformType } from "./usePlatformType";
import { PlatformTypeContext } from "./PlatformTypeContext";

export const PlatformTypeProvider: React.FC<React.PropsWithChildren<any>> = ({
  children,
}) => {
  const auth = usePlatformType();
  return (
    <PlatformTypeContext.Provider value={auth}>
      {children}
    </PlatformTypeContext.Provider>
  );
};

export const usePlatformTypeContext = () =>
  React.useContext(PlatformTypeContext);
